import { render, staticRenderFns } from "./hgyd.vue?vue&type=template&id=21449096&scoped=true&"
import script from "./hgyd.vue?vue&type=script&lang=js&"
export * from "./hgyd.vue?vue&type=script&lang=js&"
import style0 from "./hgyd.vue?vue&type=style&index=0&id=21449096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21449096",
  null
  
)

export default component.exports